export const getNotificationDestination = (notification = {}) => {
  const directTarget =
    notification.action_url ??
    notification.actionUrl ??
    notification.target_url ??
    notification.redirect_url ??
    notification.deep_link ??
    notification.route ??
    notification.link ??
    notification.url;

  if (typeof directTarget === "string" && directTarget.trim()) {
    return directTarget.trim();
  }

  const data = notification.data ?? notification.metadata ?? {};
  const screen = String(data.screen ?? "").trim().toUpperCase();
  const orderId =
    notification.order_id ??
    notification.orderId ??
    data.order_id ??
    data.orderId;

  if (screen === "REFUND_DETAIL") return null;
  if (screen === "ORDER_TRACKING") {
    return orderId ? `/account/track/${encodeURIComponent(orderId)}` : "/account/track";
  }
  if (screen === "ORDER_DETAIL") {
    return orderId ? `/account/orders/${encodeURIComponent(orderId)}` : "/account/orders";
  }
  if (orderId) return `/account/orders/${encodeURIComponent(orderId)}`;

  const text = `${notification.type ?? ""} ${notification.title ?? ""} ${notification.message ?? ""}`.toLowerCase();
  if (/order|shipped|dispatch|deliver/.test(text)) return "/account/orders";
  if (/offer|promo|deal|discount|coupon|stock|available/.test(text)) return "/products";

  return null;
};
